import * as React from "react";

function IconTruck(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M22.794 13.7l-.305-.655H15.86v5.609h.821c-.004-.058-.017-.113-.017-.173a2.565 2.565 0 015.13 0c0 .06-.013.115-.018.173h.286c.52 0 .943-.422.943-.943v-3.057c0-.329-.072-.654-.211-.954z"
        fill="#CBCFD2"
      />
      <path
        d="M15.86 7.43V4.89a.943.943 0 00-.943-.944H1.937a.943.943 0 00-.942.943v12.822c0 .52.422.943.943.943H2.96c-.004-.058-.017-.113-.017-.173a2.565 2.565 0 015.13 0c0 .06-.013.115-.018.173h7.805V7.429z"
        fill="#4F95FE"
      />
      <path
        d="M22.489 13.045l-2.152-4.627a1.71 1.71 0 00-1.55-.989h-2.926v5.616h6.629-.001zM5.508 15.917a2.565 2.565 0 00-2.565 2.565c0 .06.014.114.018.172a2.558 2.558 0 002.547 2.393 2.558 2.558 0 002.548-2.393c.004-.058.017-.113.017-.172a2.565 2.565 0 00-2.565-2.565zm0 3.59a1.026 1.026 0 11.001-2.052 1.026 1.026 0 010 2.053zM19.229 15.917a2.565 2.565 0 00-2.565 2.565c0 .06.013.114.017.173a2.558 2.558 0 002.548 2.392 2.558 2.558 0 002.547-2.392c.004-.059.018-.114.018-.173a2.565 2.565 0 00-2.565-2.565zm0 3.59a1.026 1.026 0 110-2.052 1.026 1.026 0 010 2.053z"
        fill="#313D4C"
      />
      <path
        d="M6.534 18.482a1.026 1.026 0 10-2.052 0 1.026 1.026 0 002.052 0zM20.255 18.482a1.026 1.026 0 10-2.053 0 1.026 1.026 0 002.053 0z"
        fill="#6B7683"
      />
    </svg>
  );
}

const MemoIconTruck = React.memo(IconTruck);
export default MemoIconTruck;
